// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/contribute_join_cta.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contribute-page-content {
    display: grid;
    grid-template-columns: 5fr 3fr;
    height: 100%;
}

@media screen and (max-width: 1000px) {
    .contribute-page-content {
        display: flex;
        flex-direction: column;
    }
    .grid-centerer {
        min-width: unset !important;
    }
    .submission-editor-scrollable {
        border-top: 5px solid var(--primaryColorBright);
        border-left: none;
    }
}

.contribution-page-header {
    font-size: 16px;
    font-weight: 400;
    padding: 4px 5px;
    color:white;
    margin:0;
    background-color: var(--primaryColorBright);
}

.grid-centerer {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100%;
    max-height: 100vh;
    box-sizing: border-box;
    overflow: hidden;
    /*padding: min(20px, 4%);*/
    min-width:400px;
}

.submission-preview-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width:100%;
    /*box-shadow: 0 0 0.3vw 0.1vw rgba(0, 0, 0, 0.169);
    border: 1px solid rgba(0, 0, 0, 0.445);*/
    border-radius: 5px;
}

.submission-editor-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    width:100%;
    font-size: 20px;
    font-family: Mulish;
    border-radius: 5px;
}

.preview-scrollable {
    height:100%;
    overflow: hidden;
}

.image-editor {
    height: 100%;
    box-sizing: border-box;
    background-image: linear-gradient(225deg, rgb(228, 32, 215), rgb(15, 182, 238));
    background-size: cover;
    overflow: auto;
}
.image-preview-pane {
    overflow: visible;
    min-height: 100%;
    display: flex;
    align-items: center;
}
.padding-provider {
    padding: 20px;
    width: -moz-fit-content;
    width: fit-content;
    margin: auto;
}

.submission-editor-scrollable {
    display:flex;
    flex-direction: column;
    overflow-y: auto;
    gap: 20px;
    box-sizing: border-box;
    padding: 20px;
    height: 100%;
}

.submission-editor-scrollable h1 {
    font-family: var(--displayFont);
    font-size: 32px;
    font-weight: 700;
    margin: 0;
    padding: 0;
}
.submission-editor-scrollable h2 {
    font-family: var(--displayFont);
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    padding: 0;
}

.minilabel {
    font-size: 14px;
    font-weight: 500;
    font-family: Mulish;
    margin-bottom: 5px;
}

.input-bordered-bottom {
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    box-sizing: border-box;
    outline: none;
    caret-color: rgba(20, 22, 22, 0.564);
    border:none;
    border-bottom: 2px solid rgba(0, 0, 0, 0.348);
    padding: 5px 10px;
    margin:0;
    font-family: Mulish;
}
.input-bordered-bottom:focus-visible {
    border-bottom: 2px solid var(--primaryColorBright);
}

.textarea-light-border {
    width: 100%;
    height: 100px;
    font-size: 16px;
    font-weight: 400;
    border-radius: 7px;
    outline: none;
    box-sizing: border-box;
    caret-color: rgba(20, 22, 22, 0.564);
    padding: 5px 10px;
    font-family: Mulish;
    resize: none;
}
.textarea-light-border:focus-visible {
    border: 2px solid var(--primaryColorBright);
}

.donation-selection-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    justify-content: center;
    box-sizing: border-box;
    width:100%;
}

.custom-donation-input-container {
    font-size: 14px;
    font-weight: 500;
    width: 100%;
    display:flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    box-sizing: border-box;
}

.custom-donation-input {
    font-size: 16px;
    font-weight: 400;
    border-radius: 5px;
    outline: none;
    box-sizing: border-box;
    caret-color: rgba(20, 22, 22, 0.564);
    border: 1px solid rgba(0, 0, 0, 0.956);
    padding: 5px 10px;
    margin:0;
    font-family: Mulish;
}

.payment-info-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    gap: 10px;
    justify-content: center;
}

.image-editor::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}
.image-editor::-webkit-scrollbar-track {
    background: transparent;
}
.image-editor::-webkit-scrollbar-thumb {
    background: rgba(241, 249, 255, 0.938);
    border-radius: 1000px;
}
.image-editor::-webkit-scrollbar-thumb:hover {
    background: rgba(168, 226, 255, 0.873);
}
.image-editor::-webkit-scrollbar-corner {
    background: transparent;
}

.editor-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width:100%;
    margin-top: auto;
}
.editor-panel-header {
    font-size: 16px;
    font-weight: 400;
    font-family: Mulish;
    margin:0;
    padding: 4px 5px;
    color:white;
    background-color: var(--primaryColorBright);
    width:100%;
    box-sizing: border-box;
    margin-bottom: auto;
    display:flex;
    align-items: center;
    justify-content: space-between;
    cursor: n-resize;
}

.editor-panel-header-controls {
    display:flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}
.editor-panel-header-button {
    border: none;
    background-color: transparent;
    cursor: pointer;
    display:flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    width: 20px;
}
.editor-panel-header-button:hover {
    background-color: rgba(0, 0, 0, 0.1);
}
.editor-panel-header-button-img {
    height: 100%;
    aspect-ratio: 1/1;
    filter: invert(100%);
}

.create-account-prompt {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-sizing: border-box;
    width:-moz-fit-content;
    width:fit-content;
    width: 100%;
    padding: 20px;
    height: 100%;
    border-radius: 8px;
    box-shadow: -1px 1px 10px 1px #0002;
    border: 1px solid #0001;
    text-align: center;
    font-weight: 600;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: 100% 65%;
    transition: 0.5s;
}

.preview-mode-selector {
    height: 35px;
    width: 100%;
    background-color: white;
    display: flex;
}
.preview-mode-selector-button {
    width: 100%;
    height: 100%;
    border: none;
    cursor: pointer;
    font-family: var(--paragraphFont);
    font-size: 16px;
    font-weight: 500;
    background-color: white;
    transition: background-color 0.2s;
    border-right: 1px solid #0002;
}
.--pmsb-selected {
    background-color: rgba(156, 198, 224, 0.372);
    border-bottom: 5px solid var(--primaryColorBright);
}

.contribute-location-info {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    gap: 10px;
    box-sizing: border-box;
    width:-moz-fit-content;
    width:fit-content;
    min-width: 100%;
    margin-top: auto;
    text-align: center;
    padding: 20px 5px;
    border: 1px solid #0002;
    border-radius: 8px;
    box-shadow: -1px 1px 5px 1px #0001;
}
.location-info-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-sizing: border-box;
    width:-moz-fit-content;
    width:fit-content;
    margin-top: auto;
    height: 100%;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/contribute/ContributePage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,+CAA+C;QAC/C,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,QAAQ;IACR,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV;4CACwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,+EAA+E;IAC/E,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAkB;IAAlB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;AACA;IACI,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,oCAAoC;IACpC,WAAW;IACX,6CAA6C;IAC7C,iBAAiB;IACjB,QAAQ;IACR,mBAAmB;AACvB;AACA;IACI,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,sCAAsC;IACtC,iBAAiB;IACjB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,sCAAsC;IACtC,qBAAqB;AACzB;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,WAAW;IACX,2CAA2C;IAC3C,UAAU;IACV,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;AACf;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,sBAAiB;IAAjB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,yDAA8D;IAC9D,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;AACjC;AACA;IACI,4CAA4C;IAC5C,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;IACT,sBAAsB;IACtB,sBAAiB;IAAjB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,kBAAkB;IAClB,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,sBAAsB;IACtB,sBAAiB;IAAjB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB","sourcesContent":[".contribute-page-content {\n    display: grid;\n    grid-template-columns: 5fr 3fr;\n    height: 100%;\n}\n\n@media screen and (max-width: 1000px) {\n    .contribute-page-content {\n        display: flex;\n        flex-direction: column;\n    }\n    .grid-centerer {\n        min-width: unset !important;\n    }\n    .submission-editor-scrollable {\n        border-top: 5px solid var(--primaryColorBright);\n        border-left: none;\n    }\n}\n\n.contribution-page-header {\n    font-size: 16px;\n    font-weight: 400;\n    padding: 4px 5px;\n    color:white;\n    margin:0;\n    background-color: var(--primaryColorBright);\n}\n\n.grid-centerer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height:100%;\n    max-height: 100vh;\n    box-sizing: border-box;\n    overflow: hidden;\n    /*padding: min(20px, 4%);*/\n    min-width:400px;\n}\n\n.submission-preview-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width:100%;\n    /*box-shadow: 0 0 0.3vw 0.1vw rgba(0, 0, 0, 0.169);\n    border: 1px solid rgba(0, 0, 0, 0.445);*/\n    border-radius: 5px;\n}\n\n.submission-editor-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width:100%;\n    font-size: 20px;\n    font-family: Mulish;\n    border-radius: 5px;\n}\n\n.preview-scrollable {\n    height:100%;\n    overflow: hidden;\n}\n\n.image-editor {\n    height: 100%;\n    box-sizing: border-box;\n    background-image: linear-gradient(225deg, rgb(228, 32, 215), rgb(15, 182, 238));\n    background-size: cover;\n    overflow: auto;\n}\n.image-preview-pane {\n    overflow: visible;\n    min-height: 100%;\n    display: flex;\n    align-items: center;\n}\n.padding-provider {\n    padding: 20px;\n    width: fit-content;\n    margin: auto;\n}\n\n.submission-editor-scrollable {\n    display:flex;\n    flex-direction: column;\n    overflow-y: auto;\n    gap: 20px;\n    box-sizing: border-box;\n    padding: 20px;\n    height: 100%;\n}\n\n.submission-editor-scrollable h1 {\n    font-family: var(--displayFont);\n    font-size: 32px;\n    font-weight: 700;\n    margin: 0;\n    padding: 0;\n}\n.submission-editor-scrollable h2 {\n    font-family: var(--displayFont);\n    font-size: 20px;\n    font-weight: 700;\n    margin: 0;\n    padding: 0;\n}\n\n.minilabel {\n    font-size: 14px;\n    font-weight: 500;\n    font-family: Mulish;\n    margin-bottom: 5px;\n}\n\n.input-bordered-bottom {\n    width: 100%;\n    font-size: 16px;\n    font-weight: 400;\n    box-sizing: border-box;\n    outline: none;\n    caret-color: rgba(20, 22, 22, 0.564);\n    border:none;\n    border-bottom: 2px solid rgba(0, 0, 0, 0.348);\n    padding: 5px 10px;\n    margin:0;\n    font-family: Mulish;\n}\n.input-bordered-bottom:focus-visible {\n    border-bottom: 2px solid var(--primaryColorBright);\n}\n\n.textarea-light-border {\n    width: 100%;\n    height: 100px;\n    font-size: 16px;\n    font-weight: 400;\n    border-radius: 7px;\n    outline: none;\n    box-sizing: border-box;\n    caret-color: rgba(20, 22, 22, 0.564);\n    padding: 5px 10px;\n    font-family: Mulish;\n    resize: none;\n}\n.textarea-light-border:focus-visible {\n    border: 2px solid var(--primaryColorBright);\n}\n\n.donation-selection-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    justify-content: center;\n    box-sizing: border-box;\n    width:100%;\n}\n\n.custom-donation-input-container {\n    font-size: 14px;\n    font-weight: 500;\n    width: 100%;\n    display:flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 10px;\n    box-sizing: border-box;\n}\n\n.custom-donation-input {\n    font-size: 16px;\n    font-weight: 400;\n    border-radius: 5px;\n    outline: none;\n    box-sizing: border-box;\n    caret-color: rgba(20, 22, 22, 0.564);\n    border: 1px solid rgba(0, 0, 0, 0.956);\n    padding: 5px 10px;\n    margin:0;\n    font-family: Mulish;\n}\n\n.payment-info-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    box-sizing: border-box;\n    gap: 10px;\n    justify-content: center;\n}\n\n.image-editor::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n.image-editor::-webkit-scrollbar-track {\n    background: transparent;\n}\n.image-editor::-webkit-scrollbar-thumb {\n    background: rgba(241, 249, 255, 0.938);\n    border-radius: 1000px;\n}\n.image-editor::-webkit-scrollbar-thumb:hover {\n    background: rgba(168, 226, 255, 0.873);\n}\n.image-editor::-webkit-scrollbar-corner {\n    background: transparent;\n}\n\n.editor-panel {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n    width:100%;\n    margin-top: auto;\n}\n.editor-panel-header {\n    font-size: 16px;\n    font-weight: 400;\n    font-family: Mulish;\n    margin:0;\n    padding: 4px 5px;\n    color:white;\n    background-color: var(--primaryColorBright);\n    width:100%;\n    box-sizing: border-box;\n    margin-bottom: auto;\n    display:flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: n-resize;\n}\n\n.editor-panel-header-controls {\n    display:flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n.editor-panel-header-button {\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    display:flex;\n    align-items: center;\n    justify-content: center;\n    height: 20px;\n    width: 20px;\n}\n.editor-panel-header-button:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n.editor-panel-header-button-img {\n    height: 100%;\n    aspect-ratio: 1/1;\n    filter: invert(100%);\n}\n\n.create-account-prompt {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    box-sizing: border-box;\n    width:fit-content;\n    width: 100%;\n    padding: 20px;\n    height: 100%;\n    border-radius: 8px;\n    box-shadow: -1px 1px 10px 1px #0002;\n    border: 1px solid #0001;\n    text-align: center;\n    font-weight: 600;\n    background-image: url('../../assets/contribute_join_cta.jpeg');\n    background-size: cover;\n    background-position: 100% 65%;\n    transition: 0.5s;\n}\n\n.preview-mode-selector {\n    height: 35px;\n    width: 100%;\n    background-color: white;\n    display: flex;\n}\n.preview-mode-selector-button {\n    width: 100%;\n    height: 100%;\n    border: none;\n    cursor: pointer;\n    font-family: var(--paragraphFont);\n    font-size: 16px;\n    font-weight: 500;\n    background-color: white;\n    transition: background-color 0.2s;\n    border-right: 1px solid #0002;\n}\n.--pmsb-selected {\n    background-color: rgba(156, 198, 224, 0.372);\n    border-bottom: 5px solid var(--primaryColorBright);\n}\n\n.contribute-location-info {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    gap: 10px;\n    box-sizing: border-box;\n    width:fit-content;\n    min-width: 100%;\n    margin-top: auto;\n    text-align: center;\n    padding: 20px 5px;\n    border: 1px solid #0002;\n    border-radius: 8px;\n    box-shadow: -1px 1px 5px 1px #0001;\n}\n.location-info-column {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    box-sizing: border-box;\n    width:fit-content;\n    margin-top: auto;\n    height: 100%;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
